import React from 'react';
import './loading.scss';

const Loading = () => {
    return (
        <div className="loading">
            <img src="/img/bone.svg" alt="Loading..." />
        </div>
    )
}

export default Loading
